var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mercado-libre-suggestion-form-validation-component',{attrs:{"variant-alert":"warning","errors-title":"Para que tu sugerencia sea válida, debes corregir los siguientes datos:","do-query":_vm.doQuery,"load-errors":_vm.loadErrors}})}
var staticRenderFns = []

export { render, staticRenderFns }